export type PlanId = "starter" | "professional" | "enterprise";

export type Plan = {
  id: PlanId;
  name: string;
  price: string;
  priceNote: string;
  description: string;
  highlights: string[];
  cta: string;
  featured?: boolean;
};

export const plans: Plan[] = [
  {
    id: "starter",
    name: "Starter",
    price: "$299",
    priceNote: "per month",
    description:
      "One brand, core operations, and enough seats for a focused home-service team.",
    highlights: [
      "1 tenant brand",
      "10 users included",
      "Dispatch, CRM, estimates & invoices",
      "Customer portal & memberships",
      "Standard reporting",
      "Email support",
    ],
    cta: "Start with Starter",
  },
  {
    id: "professional",
    name: "Professional",
    price: "$699",
    priceNote: "per month",
    description:
      "Multi-brand operators who need marketing automation, AI dispatch, and room to grow.",
    highlights: [
      "3 brands under one tenant",
      "40 users included",
      "Everything in Starter",
      "Marketing automation & campaigns",
      "AI-assisted dispatch",
      "Advanced analytics & priority support",
    ],
    cta: "Choose Professional",
    featured: true,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "Custom",
    priceNote: "talk to sales",
    description:
      "Unlimited brands, every module, dedicated support, and implementation for multi-location groups.",
    highlights: [
      "Unlimited brands & users",
      "All modules included",
      "Dedicated success manager",
      "Custom integrations & SSO options",
      "Usage planning for AI voice at scale",
      "Security review & onboarding package",
    ],
    cta: "Talk to sales",
  },
];

export const addOns = [
  {
    name: "Accounting",
    price: "$99/mo",
    detail: "Books, job costing, and financial close workflows tied to field work.",
  },
  {
    name: "Inventory",
    price: "$79/mo",
    detail: "Warehouse, truck stock, purchase orders, and parts visibility.",
  },
  {
    name: "Workforce",
    price: "$49/mo",
    detail: "Scheduling extras for Starter teams that need tighter labor control.",
    note: "Starter only",
  },
  {
    name: "AI voice bundles",
    price: "Usage-based",
    detail:
      "Minute packs for AI answering, booking, and after-hours coverage. Scale as call volume grows.",
  },
];

export const faqs = [
  {
    q: "What counts as a brand?",
    a: "A brand is a customer-facing business identity under your tenant — for example a parent company plus DBAs or regional names. Starter includes one; Professional includes three; Enterprise is unlimited.",
  },
  {
    q: "Are voice minutes and SMS included?",
    a: "Plans include platform access. AI voice minutes, SMS, and AI credits are metered. Buy usage bundles that match your call volume, then pay only for overages beyond those bundles.",
  },
  {
    q: "Can we start on Starter and upgrade later?",
    a: "Yes. Move to Professional or Enterprise when you add brands, seats, or modules. Your data, customers, and history stay with you.",
  },
  {
    q: "Does pricing include TrexField for technicians?",
    a: "Yes. TrexField is part of the ServiTrex platform. Seat counts cover office users and field users under your plan limits.",
  },
  {
    q: "Is there a long-term contract?",
    a: "Month-to-month for Starter and Professional. Enterprise agreements are tailored with your team during onboarding.",
  },
  {
    q: "Who is ServiTrex built for?",
    a: "Home-service companies — HVAC, plumbing, electrical, roofing, and multi-trade operators — that want one system for office, field, and phone operations.",
  },
];
